import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ColorService {
  // private usedHues: Set<number> = new Set(); // To avoid duplicate colors
  //
  // constructor() {}
  //
  // getUniqueColorDark(): string {
  //   return this.getUniqueColor('dark');
  // }
  //
  // getUniqueColorLight(): string {
  //   return this.getUniqueColor('light');
  // }
  //
  getColorFromStringDark(input: string): string {
    return this.getColorFromString(input);
  }

  getColorFromStringLight(input: string): string {
    return this.getColorFromString(input, 'light');
  }

  private static readonly GOLDEN_RATIO = 0.61803398875; // Ensures good color spread

  /**
   * Generates a consistent and well-separated color based on a string input.
   * @param input The string to hash into a color.
   * @param type 'dark' | 'light' - Defines brightness.
   * @returns Hex color string
   */
  getColorFromString(input: string, type: 'dark' | 'light' = 'dark'): string {
    const hue = this.stringToHue(input);
    const saturation = 40; // High saturation for vibrancy
    const lightness = type === 'dark' ? 25 : 80; // Keep good contrast

    return this.hslToHex(hue, saturation, lightness);
  }

  /**
   * Converts a string into a well-spaced hue (0-360°)
   */
  private stringToHue(input: string): number {
    let hash = 0;
    for (let i = 0; i < input.length; i++) {
      hash = input.charCodeAt(i) + ((hash << 5) - hash);
    }

    // Spread hue values evenly across the spectrum using the golden ratio
    let hue = Math.abs(hash) % 360;
    hue = (hue * ColorService.GOLDEN_RATIO * 360) % 360;

    return Math.round(hue);
  }

  /**
   * Converts HSL to Hex
   */
  private hslToHex(h: number, s: number, l: number): string {
    s /= 100;
    l /= 100;
    const k = (n: number) => (n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n: number) =>
      Math.round((l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)))) * 255)
        .toString(16)
        .padStart(2, '0');

    return `#${f(0)}${f(8)}${f(4)}`;
  }

  // getColorFromString(input: string, type: 'dark' | 'light' = 'dark'): string {
  //   const hue = this.stringToHue(input); // Convert string to a hue (0-360°)
  //   const saturation = 80; // Keeps colors vibrant
  //   const lightness = type === 'dark' ? 30 : 85; // Adjust brightness
  //
  //   return this.hslToHex(hue, saturation, lightness);
  // }
  //
  // /**
  //  * Converts a string to a fixed hue value (0-360°)
  //  */
  // private stringToHue(input: string): number {
  //   let hash = 0;
  //   for (let i = 0; i < input.length; i++) {
  //     hash = input.charCodeAt(i) + ((hash << 5) - hash); // Simple hash function
  //   }
  //   return Math.abs(hash) % 360; // Keep hue in range 0-360°
  // }
  //
  // /**
  //  * Converts HSL to Hex
  //  */
  // private hslToHex(h: number, s: number, l: number): string {
  //   s /= 100;
  //   l /= 100;
  //   const k = (n: number) => (n + h / 30) % 12;
  //   const a = s * Math.min(l, 1 - l);
  //   const f = (n: number) =>
  //     Math.round((l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)))) * 255)
  //       .toString(16)
  //       .padStart(2, '0');
  //
  //   return `#${f(0)}${f(8)}${f(4)}`;
  // }
  // getUniqueColor(type: 'dark' | 'light'): string {
  //   let hue;
  //   do {
  //     hue = Math.floor(Math.random() * 360); // Random hue (0-360°)
  //   } while (this.usedHues.has(hue)); // Ensure uniqueness
  //
  //   this.usedHues.add(hue);
  //
  //   const saturation = 80; // Keeps colors vibrant
  //   const lightness = type === 'dark' ? 30 : 85; // Adjust brightness
  //
  //   return this.hslToHex(hue, saturation, lightness);
  // }
  //
  // /**
  //  * Converts HSL to Hex
  //  */
  // private hslToHex(h: number, s: number, l: number): string {
  //   s /= 100;
  //   l /= 100;
  //   const k = (n: number) => (n + h / 30) % 12;
  //   const a = s * Math.min(l, 1 - l);
  //   const f = (n: number) =>
  //     Math.round((l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)))) * 255)
  //       .toString(16)
  //       .padStart(2, '0');
  //
  //   return `#${f(0)}${f(8)}${f(4)}`;
  // }
}
